// extracted by mini-css-extract-plugin
export default {"List":"ChangeArchive_List__9jBcs","TableWrapper":"ChangeArchive_TableWrapper__uNUIl"};